// extracted by mini-css-extract-plugin
export var growableInput = "_7z-0";
export var tagContainer = "_7z-2";
export var textInput = "_7z-1";